import { useApolloClient } from '@apollo/client';
import { isAfisCyprus } from 'shared-pages/common/constants';
import {
  getCollectionById,
  getCollectorById,
  getCollectorIdocSeriesId,
  getDriverById,
  getVehicleById,
  getWasteReceptionPointById,
  getCollectionpointById,
} from 'shared-pages/pages/idocs/graphql';

export function useIdocFormHandlers(setFieldValue: (field: string, value: any) => void) {
  const client = useApolloClient();

  const updateCollectionPointFields = async (id: number) => {
    // const rec = await getWasteReceptionPointById(client, id);
    const rec = await getCollectionpointById(client, id);
    if (!rec) return;

    setFieldValue('collectionPointId', rec.id);
    setFieldValue('collectionPointName', rec.name);
    setFieldValue('colpointAddressLine1', rec.addressLine1);
    setFieldValue('colpointAddressLine2', rec.addressLine2);
    setFieldValue('colpointAddressArea', rec.addressArea);
    setFieldValue('colpointAddressCity', rec.addressCity);
    setFieldValue('colpointPostalCode', rec.postalCode);
    setFieldValue('colpointPhoneNumber', rec.phone);
    !isAfisCyprus && setFieldValue('colpointVatNumber', rec.companyVat);
    !isAfisCyprus && setFieldValue('colpointTaxOffice', rec.companyTaxOffice);
    setFieldValue('regionId', rec.regionId);
    setFieldValue('subregionId', rec.subregionId);
    setFieldValue('colpointContactPerson', rec.contactPerson);
    setFieldValue('colpointCategoryId', rec.categoryId);
    setFieldValue('colpointImaCode', rec.imaCode);
  };

  const onCollectorIdChange = async (option) => {
    if (!option?.value) return;
    const collector = await getCollectorById(client, option.value);
    setFieldValue('collectorId', collector.id);
    setFieldValue('collectorCompanyName', collector.name);
    setFieldValue('collectorCompanyAddress', collector.addressLine1);
    setFieldValue('collectorCompanyPhoneNumber', collector.phone);
    setFieldValue('collectorCompanyVat', collector.companyVat);
    !isAfisCyprus && setFieldValue('collectorCompanyTaxOffice', collector.companyTaxOffice);
    setFieldValue('collectorCompanyImaCode', collector.imaCode);
    // καθάρισε τα πεδία του οδηγού
    setFieldValue('driverId', null);
    setFieldValue('driverFullName', null);
    setFieldValue('driverSignFileId', null);
    setFieldValue('adrNumber', null);
    const series = await getCollectorIdocSeriesId(client, collector.id);
    setFieldValue('idocseriesId', series?.data?.[0]?.id);
    setFieldValue('idocPrefix', series?.data?.[0]?.docPrefix);
  };

  const updateDriverFields = async (id: number, onSuccess?: () => void) => {
    const rec = await getDriverById(client, id);
    if (!rec || rec === null) return;

    setFieldValue('driverId', rec.id);
    setFieldValue('driverFullName', rec.name);
    setFieldValue('driverSignFileId', rec.user?.signFileId);
    setFieldValue('adrNumber', rec.adrNumber);
    if (onSuccess) {
      onSuccess();
    }
  };

  const updateVehicleFields = async (id: number, onSuccess?: () => void) => {
    const rec = await getVehicleById(client, id);
    if (!rec || rec === null) return;

    setFieldValue('vehicleId', rec.id);
    setFieldValue('vehPlateNumber', rec.plateNumber);
    if (onSuccess) {
      onSuccess();
    }
  };

  const onCollectionChange = async (value) => {
    if (!value) return;

    const collectionId = parseInt(value);
    const collection = await getCollectionById(client, collectionId);
    if (!collection) return;

    // Clear fields
    setFieldValue('collectionPointId', null);
    setFieldValue('collectionPointName', '');
    setFieldValue('colpointAddressLine1', '');
    setFieldValue('colpointAddressLine2', '');
    setFieldValue('colpointAddressArea', '');
    setFieldValue('colpointAddressCity', '');
    setFieldValue('colpointPostalCode', '');
    setFieldValue('colpointPhoneNumber', '');
    !isAfisCyprus && setFieldValue('colpointVatNumber', '');
    !isAfisCyprus && setFieldValue('colpointTaxOffice', '');
    setFieldValue('regionId', null);
    setFieldValue('rbGeoAreaId', null);
    setFieldValue('colpointContactPerson', '');
    setFieldValue('colpointCategoryId', null);
    setFieldValue('colpointImaCode', null);

    // Apply new data
    if (collection.collectionPointId) {
      await updateCollectionPointFields(collection.collectionPointId);
    }
  };

  const onWastereceptionpointChange = async (option) => {
    if (!option?.value) return;
    const rec = await getWasteReceptionPointById(client, option.value);
    if (!rec) return;

    setFieldValue('wastereceptionpointId', rec.id);
    setFieldValue('wastereceptionpointCompanyName', rec.formalName ?? rec.name);
    setFieldValue('wastereceptionpointCompanyAddress', rec.addressLine1);
    setFieldValue('wastereceptionpointCompanyPhoneNumber', rec.phone);
    setFieldValue('wastereceptionpointCompanyVat', rec.companyVat);
    !isAfisCyprus && setFieldValue('wastereceptionpointCompanyTaxOffice', rec.companyTaxOffice);
    setFieldValue('wastereceptionpointCompanyImaCode', rec.imaCode);
    setFieldValue('wastereceptionpointCompanyEmail', rec.email);
    setFieldValue('wastereceptionpointCompanyRegionId', rec.regionId);
    setFieldValue('wastereceptionpointCompanySubregionId', rec.subregionId);
    setFieldValue('receptionPersonName', rec.receptionPersonName);
    setFieldValue('wasteDestinationTypeId', rec.wasteDestinationTypeId);
  };

  return {
    updateCollectionPointFields,
    onCollectorIdChange,
    updateDriverFields,
    updateVehicleFields,
    onWastereceptionpointChange,
    onCollectionChange,
  };
}
